<template lang='pug'>
  v-card(v-if='loaded')
    v-card-title
      v-row(no-gutters)
        v-col(cols='10' no-gutters)
          .text-h5.font-weight-light.text-ellipsis {{test.name}}
          .text-caption.font-weight-light.text-ellipsis {{loadTest.baseUrl}}
        v-spacer
        v-menu(offset-y left)
          template(v-slot:activator='{on}')
            v-btn.mr-1(text icon v-on='on' @mousedown.stop)
              v-icon more_vert
          v-list
            v-list-item(:to='`/results/${runGuid}`')
              v-list-item-title View Raw Results
            v-list-item(@click='downloadXlsx')
              v-list-item-title Download XLSX
    v-card-text
      v-row(no-gutters).mt-4.mb-4
        v-col.text-center
          .text-h2.text--primary {{result.running || 0}}
          .text-subtitle-1.grey--text Running
        v-col.text-center
          .text-h2.green--text.accent-4 {{result.passing || 0}}
          .text-subtitle-1.grey--text Passing
        v-col.text-center
          .text-h2.deep-orange--text.text--darken-3 {{result.failing || 0}}
          .text-subtitle-1.grey--text Failing
    bionic-metrics-summary-chart(:total='result.total' :passing='result.passing' :result='result.failing')
</template>

<script>
import UtilMixin from '@/mixins/util.mixin';
import BionicMetricsSummaryChart from '@/components/SummaryChart';
import LoadTest from '@/api/loadTest';

export default {
  name: 'BionicMetricsLoadTestCard',
  components: {BionicMetricsSummaryChart},
  mixins: [UtilMixin],
  props: {
    loadTest: {
      type: Object
    },
    test: {
      type: Object
    },
    result: {
      type: Object
    },
    runGuid: {
      type: String
    }
  },
  computed: {
    loaded() {
      return this.loadTest && this.test && this.result;
    }
  },
  methods: {
    async downloadXlsx() {
      const url = await LoadTest.downloadXlsx(this.loadTest.guid, this.runGuid);
      window.location = url;
    }
  }
};
</script>

<style scoped>
</style>
